import bookingService from 'components/Booking-new/services/BookingService';

const isServiceAllowed = async serviceCode => {
  const { data, error } = await bookingService.getAllowedServices();

  const serviceAllowed = data.some(service => service.allowedService === serviceCode);

  return {
    serviceAllowed,
    error,
  };
};

export default isServiceAllowed;
